import { Text, Title } from "ui/atoms";
import styled from "styled-components";
import { Screens } from "helpers/screens";
import SmileyIcon from "svg/smiley.svg";
import { ReactElement } from "react";

const UspsData = [
    {
        title: "Voor elke stap",
        description:
            "Vrijblijvend rondkijken of alles regelen – met financiering, garantie en verzekering; voor alles ben je bij ons welkom."
    },
    {
        title: "Geen verrassingen",
        description:
            "Met het meest complete autorapport weet je altijd precies waar je aan toe bent met de auto die je op het oog hebt."
    },
    {
        title: "Altijd dichtbij",
        description:
            "Met ruim 5.200 aangesloten autobedrijven, vind je bij ons altijd auto’s die bij jou in de buurt staan."
    }
] as const;

const UspsContainer = styled.div`
    display: grid;
    gap: 2rem;
    padding: 0 2rem;

    @media (${Screens.get("lg")}) {
        grid-template-columns: repeat(3, 1fr);
        padding: 0 3.5rem;
    }
`;

const UspWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const TitleLogoWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.75rem;
`;

const TitleText = styled(Title)`
    align-self: center;
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
    font-family: ${({ theme }) => theme.typography.fontFamily.secondary};
`;

const DescriptionText = styled(Text)`
    font-weight: ${({ theme }) => theme.typography.fontWeight.regular};
    font-family: ${({ theme }) => theme.typography.fontFamily.primary};
    line-height: 1.5rem;
`;

const CheckText = styled(Text)`
    font-size: 0.875rem;
    align-self: center;
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
    font-family: ${({ theme }) => theme.typography.fontFamily.secondary};
`;

const IconTextWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
    color: ${({ theme }) => theme.colors.secondary[700]};

    svg {
        width: 1rem;
        height: 0.625rem;
        fill: currentColor;
    }
`;

export const Usps = (): ReactElement => {
    return (
        <UspsContainer>
            {UspsData.map((item) => {
                return (
                    <UspWrapper key={item.title}>
                        <TitleLogoWrapper>
                            <TitleText as="h2">{item.title}</TitleText>
                            <IconTextWrapper>
                                <SmileyIcon />
                                <CheckText as="span">Check.</CheckText>
                            </IconTextWrapper>
                        </TitleLogoWrapper>
                        <DescriptionText as="span">{item.description}</DescriptionText>
                    </UspWrapper>
                );
            })}
        </UspsContainer>
    );
};
